import Silos from './SilosScreen'

export default Silos
export { Silos }
